import React, { PureComponent } from "react";
import classNames from "classnames";
import css from "./style.scss";
import dropdownable from "./decorate";
import PropTypes from "prop-types";
import CampaignAutoDropdown from "../../../components/SearchDropdown/CampaignAutoDropdown.js"

function buildItems({ groups, options, placeholder }) {
  const items = [];

  if (groups && Array.isArray(groups)) {
    groups.forEach((group, gi) => {
      const groupLabel = group?.label;
      if (groupLabel) {
        items.push({
          id: `__group__${gi}__${groupLabel}`,
          name: groupLabel,
          value: null,
          isGroup: true,
        });
      }

      const groupOptions = Array.isArray(group?.options) ? group.options : [];
      groupOptions.forEach((opt, oi) => {
        if (typeof opt === "string") {
          items.push({
            id: `${opt}-${oi}`,
            name: opt,
            value: opt,
          });
        } else if (opt && typeof opt === "object") {
          const { value, label = value } = opt;
          items.push({
            id: `${String(value)}-${oi}`,
            name: String(label ?? ""),
            value,
          });
        }
      });
    });

    return items;
  }

  const opts = Array.isArray(options) ? options : [];

  if (placeholder) {
    items.push({
      id: "__placeholder__",
      name: placeholder,
      value: null,
      isGroup: true,
    });
  }

  opts.forEach((opt, i) => {
    if (typeof opt === "string") {
      items.push({ id: `${opt}-${i}`, name: opt, value: opt });
    } else if (opt && typeof opt === "object") {
      const { value, label = value } = opt;
      items.push({
        id: `${String(value)}-${i}`,
        name: String(label ?? ""),
        value,
      });
    }
  });
  return items;
}

class CampaignDropdown extends PureComponent {
  render() {
    const {
      className,
      disabled,
      name,
      onChange,
      groups,
      options,
      placeholder,
      input,
      onChangeValue,
      label,
      required,
      showLabel,
      ...rest
    } = this.props;

    const items = buildItems({ groups, options, placeholder });

    const currentValue = (input && input.value !== undefined ? input.value : this.props.value) ?? null;

    const selectedItem =  items.find((i) => !i.isGroup && String(i.value) === String(currentValue)) || null;

    return (
      <div className={classNames(className, css.dropdown)} {...rest}>
        <CampaignAutoDropdown
          // label={label || "Target Leads*"}
          required={!!required}
          placeholder={placeholder || "Select Leads"}
          items={items}
          value={selectedItem}
          noDataMessage={"No results found"}
          showLabel={showLabel}
          disabled={disabled}
          onSelect={(item) => {
            if (!item || item.isGroup) return;
            const syntheticEvent = {
              target: {
                name,
                value: item.value,
              },
            };
            if (input && typeof input.onChange === "function") {
              input.onChange(item.value);
            }
            if (onChange) onChange(syntheticEvent);
            if (onChangeValue) onChangeValue(item.value);
          }}
        />
      </div>
    );
  }
}

CampaignDropdown.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.instanceOf(Array),
  groups: PropTypes.instanceOf(Array),
  label: PropTypes.string,
  required: PropTypes.bool,
};

CampaignDropdown.defaultProps = {
  onChange: () => {},
  input: {},
};

export { dropdownable };
export default CampaignDropdown;